//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'TubularPhosphateReabsorption',
  data() {
    return {
      defaultJson:{
        "Pl Creatinine": "血肌酐",
        "Pl Phosphate": "血磷",
        "TRP": "肾小管磷重吸收",
        "U Creatinine": "尿肌酐",
        "U Phosphate": "尿磷"
      },
      form:{
        ppo:'',
        pcreat:'',
        upo:'',
        ucreat:'',
      },
      res2:'--',
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.res2 ='--'
        return '--'
      } else {
        // 100-((upo*pcreat)/(10*ppo*ucreat))
        let result = 100-((form.upo*form.pcreat)/(10*form.ppo*form.ucreat))
        
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/TubularPhosphateReabsorption.vue